// extracted by mini-css-extract-plugin
export default {"wrapper":"StretchToMobileLayoutEdge_wrapper__Tf8Lj"};